<script setup lang="ts">
const route = useRoute()
const { data: pageContent } = await useAsyncData(`content:pages${route.path}`, () => queryContent(`pages${route.path}`).findOne())

useSeoMeta({
  description: pageContent.value?.description,
  ogDescription: pageContent.value?.description,
  ogTitle: pageContent.value?.title,
  title: pageContent.value?.title,
})

 import.meta.prerender && defineOgImageComponent('TitleCard', {
  description: pageContent.value?.landing.description,
  title: pageContent.value?.landing.title,
})
</script>

<template>
  <DotHeader v-bind="pageContent?.landing"/>

  <ULandingSection
    v-for="(section, index) in pageContent?.sections"
    :key="index"
    v-bind="section"
    :align="index % 2 === 0 ? 'left' : 'right'"
    :ui="{
      icon: {
        base: 'lg:hidden'
      }
    }"
  >
    <UIcon
      :name="section.icon"
      :class="[index % 2 === 0 ? 'bg-gradient-to-br' : 'bg-gradient-to-bl']"
      class="max-md:hidden size-full from-cyan-100 via-primary-500 to-indigo-950"
    />
  </ULandingSection>

  <ConnectCard/>
</template>
